var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 68,
    viewBox: "0 0 85 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.32V7.36962C0 3.29785 3.42835 0 7.65232 0H24.0853C25.7054 0 27.2822 0.495027 28.5913 1.41536L35.7446 6.44232H77.3549C81.5789 6.44232 85 9.74018 85 13.8119V19.32H0Z",
    fill: "#725CDA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7602 9.48242H9.08729C4.98591 9.48242 1.66406 12.7437 1.66406 16.7704V58.1813C1.66406 62.2079 4.98591 65.4692 9.08729 65.4692H76.7672C80.8686 65.4692 84.1905 62.2079 84.1905 58.1813V16.7704C84.1905 12.7437 80.8616 9.48242 76.7602 9.48242Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3483 11.3848H7.65289C3.42893 11.3848 0.0078125 14.6826 0.0078125 18.7544V60.6295C0.0078125 64.7012 3.42893 67.9991 7.65289 67.9991H77.3555C81.5795 67.9991 85.0006 64.7012 85.0006 60.6295V18.7544C85.0006 14.6826 81.5722 11.3848 77.3483 11.3848Z",
    fill: "#917AFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.314453095fc2f779a80692cbb92acae8.svg";
export { ForwardRef as ReactComponent };